var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { bankIDApi } from "apis/eduidBankid";
import { eidasApi } from "apis/eduidEidas";
import { frejaeIDApi } from "apis/eduidFrejaeID";
import { useAppSelector } from "eduid-hooks";
import { useCallback } from "react";
import { Form as FinalForm } from "react-final-form";
import { FormattedMessage, useIntl } from "react-intl";
import Select from "react-select";
import BankIdFlag from "../../../img/flags/BankID_logo.svg";
import EuFlag from "../../../img/flags/EuFlag.svg";
import FrejaFlag from "../../../img/flags/FOvalIndigo.svg";
import GlobalFlag from "../../../img/flags/GlobalFlag.svg";
const IconWithText = ({ icon, text }) => {
    return (_jsxs(_Fragment, { children: [icon, _jsx("span", { className: "select-option-text", children: text })] }));
};
export function RecoveryOptions({ recoveryAvailable, }) {
    const intl = useIntl();
    const email_code = useAppSelector((state) => state.resetPassword.email_code);
    const ref = useAppSelector((state) => state.login.ref);
    const frontend_action = location.pathname.includes("login") ? "loginMfaAuthn" : "resetpwMfaAuthn";
    const frontend_state = location.pathname.includes("login") ? ref : email_code;
    const [bankIDMfaAuthenticate] = bankIDApi.useLazyBankIDMfaAuthenticateQuery();
    const [eidasMfaAuthenticate] = eidasApi.useLazyEidasMfaAuthenticateQuery();
    const [frejaMfaAuthenticate] = frejaeIDApi.useLazyFrejaeIDMfaAuthenticateQuery();
    const placeholder = intl.formatMessage({
        id: "recoveryOptions.placeholder",
        defaultMessage: "Show other options",
        description: "placeholder text for recovery option",
    });
    const allOptions = [
        {
            value: "Bank ID",
            label: (_jsx(IconWithText, { icon: _jsx("img", { height: "35", className: "circle-icon bankid-icon", alt: "", src: BankIdFlag }), text: _jsx(FormattedMessage, { id: "recoveryOptions.bank", defaultMessage: `BankID` }) })),
            available: recoveryAvailable.swedish_eid,
        },
        {
            value: "Freja+",
            label: (_jsx(IconWithText, { icon: _jsx("img", { className: "circle-icon", height: "35", alt: "", src: FrejaFlag }), text: _jsx(FormattedMessage, { id: "recoveryOptions.frejaSuu", defaultMessage: `Freja+` }) })),
            available: recoveryAvailable.swedish_eid,
        },
        {
            value: "eIDAS",
            label: (_jsx(IconWithText, { icon: _jsx("img", { className: "circle-icon", height: "35", alt: "", src: EuFlag }), text: _jsx(FormattedMessage, { id: "recoveryOptions.e", defaultMessage: `eIDAS` }) })),
            available: recoveryAvailable.eidas,
        },
        {
            value: "Freja eID",
            label: (_jsx(IconWithText, { icon: _jsx("img", { className: "circle-icon", height: "35", alt: "", src: GlobalFlag }), text: _jsx(FormattedMessage, { id: "recoveryOptions.freja", defaultMessage: `Freja eID` }) })),
            available: recoveryAvailable.freja_eid,
        },
    ];
    const options = allOptions.filter((option) => option.available);
    const handleAuthenticate = useCallback((method) => __awaiter(this, void 0, void 0, function* () {
        const authenticateMap = {
            bankid: bankIDMfaAuthenticate,
            freja: eidasMfaAuthenticate,
            eidas: eidasMfaAuthenticate,
            freja_eid: frejaMfaAuthenticate,
        };
        const authenticate = authenticateMap[method];
        const response = yield authenticate({
            method: method,
            frontend_action: frontend_action,
            frontend_state: frontend_state,
        });
        if (response.isSuccess) {
            if (response.data.payload.location) {
                globalThis.location.assign(response.data.payload.location);
            }
        }
    }), [bankIDMfaAuthenticate, eidasMfaAuthenticate, frejaMfaAuthenticate, frontend_action, frontend_state]);
    const handleOnChange = useCallback((newValue) => {
        if ((newValue === null || newValue === void 0 ? void 0 : newValue.value) === "Bank ID") {
            handleAuthenticate("bankid");
        }
        else if ((newValue === null || newValue === void 0 ? void 0 : newValue.value) === "Freja+") {
            handleAuthenticate("freja");
        }
        else if ((newValue === null || newValue === void 0 ? void 0 : newValue.value) === "eIDAS") {
            handleAuthenticate("eidas");
        }
        else if ((newValue === null || newValue === void 0 ? void 0 : newValue.value) === "Freja eID") {
            handleAuthenticate("freja_eid");
        }
    }, [handleAuthenticate]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "or-container", children: [_jsx("div", { className: "line" }), _jsx("span", { children: _jsx(FormattedMessage, { id: "recoveryOptions.having", defaultMessage: "Having issues using a security key?" }) }), _jsx("div", { className: "line" })] }), _jsxs("div", { className: "option-wrapper", children: [_jsx(FinalForm, { onSubmit: () => { }, render: ({ handleSubmit }) => (_jsx("form", { onSubmit: handleSubmit, children: _jsx(Select, { options: options, onChange: handleOnChange, placeholder: placeholder, isSearchable: false, className: "mfa-select", classNamePrefix: "react-select", isDisabled: !recoveryAvailable.swedish_eid && !recoveryAvailable.freja_eid && !recoveryAvailable.eidas }) })) }), !recoveryAvailable.swedish_eid && !recoveryAvailable.freja_eid && !recoveryAvailable.eidas && (_jsx("p", { className: "help-text", children: _jsx(FormattedMessage, { id: "recoveryOptions.mfa", description: "MFA recovery help text", defaultMessage: "Requires that you have verified your identity in eduID with a Swedish personal identity number or coordination number, eIDAS, or Freja eID." }) }))] })] }));
}
